import { Pipe, PipeTransform } from "@angular/core";
import { ChanceNodeActionDto, ChanceNodeDto } from "@api";

@Pipe({ name: "getActions" })
export class GetActionsPipe implements PipeTransform {
  public transform(chanceNode: ChanceNodeDto, reason: boolean): ChanceNodeActionDto[] {
    return chanceNode?.actions?.filter(chanceNodeAction => chanceNodeAction.reason === reason);
  }
}
